import { createEmailOTPMagicWalletConnector } from './connectors/EmailOTPMagicWalletConnector/EmailOTPMagicWalletConnector.js';
import { createMagicSocialWalletConnector } from './connectors/MagicSocialWalletConnector/MagicSocialWalletConnector.js';
import { MagicFlowWalletConnector } from './chains/MagicFlowWalletConnector/MagicFlowWalletConnector.js';

const MagicFlowWalletConnectors = (props) => {
    var _a;
    if (!((_a = props.apiProviders.magicLink) === null || _a === void 0 ? void 0 : _a.providerProjectId)) {
        return [];
    }
    return [
        createEmailOTPMagicWalletConnector(MagicFlowWalletConnector),
        createMagicSocialWalletConnector(MagicFlowWalletConnector),
    ];
};

export { MagicFlowWalletConnectors };
